// @flow
import * as React from 'react'

import './ImageHero.scss'

type Props = {
  imageUrl: string,
  children: React.Node,
}

export default class ImageHero extends React.Component<Props> {
  render = () => {
    return (
      <div className="ImageHero">
        <div className="ImageHero-image" style={this.backgroundImageStyle} />
        <div className="ImageHero-content">{this.props.children}</div>
      </div>
    )
  }

  get backgroundImageStyle(): {} {
    return { backgroundImage: `url(${this.props.imageUrl})` }
  }
}
